import { render, staticRenderFns } from "./problemStudentDetail.vue?vue&type=template&id=d9b070a8&scoped=true"
import script from "./problemStudentDetail.vue?vue&type=script&lang=js"
export * from "./problemStudentDetail.vue?vue&type=script&lang=js"
import style0 from "./problemStudentDetail.vue?vue&type=style&index=0&id=d9b070a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b070a8",
  null
  
)

export default component.exports